module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [
      "modal",
      ("modal--" + _vm.id),
      "cover--fixed",
      {
        'modal--active': _vm.active,
        'modal--auth': _vm.auth,
        'modal--auto': _vm.auto,
      } ]
  }, [_c('div', {
    staticClass: "modal__bg cover",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal__wrapper"
  }, [(_vm.hasHeader) ? _c('div', {
    staticClass: "modal__header"
  }, [(!_vm.noClose) ? _c('module-modal-close') : _vm._e(), _vm._v(" "), _vm._t("header")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal__content"
  }, [_c('div', {
    staticClass: "modal__inner"
  }, [(!_vm.hasHeader && !_vm.noClose) ? [_c('module-modal-close'), _vm._v(" "), _c('span', {
    staticClass: "modal__float",
    attrs: {
      "aria-hidden": "true"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.visible) ? [(_vm.auth) ? _c('ui-auth', {
    attrs: {
      "slug": _vm.auth,
      "modal": true,
      "success": function () {
        _vm.closeModal();
      }
    }
  }) : _vm._t("default")] : _vm._e()], 2)]), _vm._v(" "), (_vm.hasFooter) ? _c('div', {
    staticClass: "modal__footer"
  }, [_vm._t("footer")], 2) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e6eff5fe"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/Modal.vue
// module id = 119
// module chunks = 3